export default __webpack_public_path__ + "static/media/Vambraces of the Ostiary.d908d198.jpg";